<template>
  <div :class="[{purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Ссылка"
          :required="true"
          :value="this.formData.openspace_url"
          @change_input="(value) => onChange('openspace_url', value)"
        />
      </div>
      <div class="form__item">
        <CustomDate
          :required="true"
          placeholder="Дата съемки"
          :value="this.formData.date_record || ''"
          @change_date="(value) => onChange('date_record', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "add-open-space-link",
  components: {CustomDate, CustomInput, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        date_record: '',
        openspace_url: '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 350px;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 428px) {
    width: 100%;
  }
}
.row {
  display: flex;
  align-items: center;
  gap: 15px;
  @media (max-width: 428px) {
    flex-direction: column;
  }
}
</style>
